<template>
  <EditorContent
    :editor="editor"
    class="textfield"
    :class="{ 'tiptap-clamped': lineClamp }"
    :style="lineClamp ? { '--max-lines': lineClamp } : {}"
  />
</template>

<script setup lang="ts">
  import { watch } from 'vue'
  import { EditorContent, type JSONContent } from '@tiptap/vue-3'
  import { useWysiwygEditor } from '@/core/composables/useWysiwygEditor'

  interface Props {
    value: JSONContent
    lineClamp?: number
    paragraphClass?: string
  }

  const props = defineProps<Props>()

  const { editor } = useWysiwygEditor(props.value, true, undefined, undefined, props.paragraphClass)

  watch(
    () => props.value,
    (newValue) => {
      if (editor.value && newValue) {
        editor.value.commands.setContent(newValue)
      }
    },
    { deep: true },
  )
</script>

<style scoped>
  .textfield.tiptap-clamped :deep(.ProseMirror) {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: var(--max-lines, 2);
    overflow: hidden;
    text-overflow: ellipsis;

    p {
      margin: 0;
    }
  }
</style>
